import { Injectable } from '@angular/core';
import {  Headers, Response, RequestOptions } from '@angular/http';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { SeguridadService } from '../_services/seguridad.service';
import { AppSettings } from '../_models/settings.models';
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class TextospredefinidosService {

  constructor(private http: HttpClient, private seguridad: SeguridadService ) { }



  getListaObservacionesTipo(idTipo){

    let userToken : string = localStorage.getItem('currentUserToken');

    let url = AppSettings.API_URL + 'index.php/api/normapro/observaciones-tipo/' + idTipo;
 
    return this.http.get(url);



  }


  getObservacion(id){

    let userToken : string = localStorage.getItem('currentUserToken');

    let url = AppSettings.API_URL + 'index.php/api/normapro/observacion/' + id;

    return this.http.get(url);
  }



  setObservacion(idTipo:number,observacion: String){


    let url = AppSettings.API_URL + 'index.php/api/normapro/observaciones';
 
    return this.http.post(url ,{idTipo:idTipo,descripcion:observacion})
        .map((response: Response) => {

 /*           if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }
*/
        });
  }

  updateObservacion(id:number,observacion:String){


    let url = AppSettings.API_URL + 'index.php/api/normapro/observaciones/'+id;

    return this.http.put(url ,{descripcion:observacion})
        .map((response: Response) => {

 /*           if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }
*/
        });
        
  }

  deleteObservacion(id:number){


    let url = AppSettings.API_URL + 'index.php/api/normapro/observaciones/' + id;

    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: id,
    };

    return this.http.delete(url,options)
        .map((response: Response) => {



        });
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/textospredefinidos.service.ts